import { render, staticRenderFns } from "./QuestionandAnswers.vue?vue&type=template&id=63e529fa&scoped=true"
import script from "./QuestionandAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionandAnswers.vue?vue&type=script&lang=js"
import style0 from "./QuestionandAnswers.vue?vue&type=style&index=0&id=63e529fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e529fa",
  null
  
)

export default component.exports